let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Ww7M")).then(() => parcelRequire('e4Icc'));